/* eslint react/prop-types: 0 */
import { FormInput } from 'camino-react'
import React from 'react'
import Select from 'react-select'

const AssignQueueAction = ({
  update,
  operations: { queue_id: queueID },
  options: { queues }
}) => (
  <FormInput label="Queue">
    <Select
      options={queues}
      value={queueID}
      onChange={e => update('queue_id', e.value)}
    />
  </FormInput>
)

export default AssignQueueAction
